export default __webpack_public_path__ + "static/Calibre-Regular-5953fa35a6c05f584064b49834274f84.ttf";